// @flow
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { type ContextRouter } from "react-router";
import { Breadcrumbs } from "../../components/Blog/Breadcrumbs";
import { Loader } from "../../components/Loader/Loader";
import { BlogIndex, containerStyles } from "../../components/Blog/BlogIndex";
import { getBlogCategorySaga } from "./ducks";
import { BlogWrapper } from "../BlogLayout";

type OuterProps = ContextRouter<{ id: string }>;

const BreadcrumbsWrapper = styled.div`
  & > div {
    ${containerStyles}
  }
`;

type Props = {
  ...OuterProps,
  content: RemoteContent<PrismicCategory>,
};

const Category = ({ content }: Props) => (
  <BlogWrapper>
    <Loader content={content}>
      {(category) => (
        <>
          <Helmet>
            <title>{category.data.name} | Nested blog</title>
          </Helmet>
          <BreadcrumbsWrapper>
            <Breadcrumbs category={category} />
          </BreadcrumbsWrapper>
          <BlogIndex
            hideCategory
            title={category.data.name}
            featuredPost={category.data.featured_post}
            posts={category.data.posts}
          />
        </>
      )}
    </Loader>
  </BlogWrapper>
);

Category.fetchData = getBlogCategorySaga;

const mapStateToProps = (state, ownProps) => ({
  content: state.blog.category[ownProps.match.params.id],
});

export const UniversalRender = connect<Props, OuterProps, _, _, _, _>(
  mapStateToProps,
)(Category);
